import { messageBus, events } from '@schibsted-nmp/advertising-events';
import { PlacementInstructionConfig } from '@schibsted-nmp/advertising-shared';

let interval;

type CompanionReadyPlacementListenerProps = {
  placementInstructionConfigs: PlacementInstructionConfig[];
  isAfsEnabled: boolean;
};
export function companionReadyPlacementListener({
  placementInstructionConfigs,
  isAfsEnabled
}: CompanionReadyPlacementListenerProps) {
  let payload = placementInstructionConfigs;
  if (!isAfsEnabled) {
    // If the Unleash feature flag is not enabled, we remove all intervals with adServer afs
    // from the payload
    // The choice to do it here instead of the hook is:
    // 1. As of now, there is no way to use the feature flags in the companion
    // 2. We do not need to re-publish a new companion version when we want to remove this code later
    payload = placementInstructionConfigs.map((config) => ({
      ...config,
      data: config.data.map((data) => ({
        ...data,
        intervals: data.intervals.filter(
          (interval) => interval.adServer !== 'afs'
        )
      }))
    }));
  }
  function publishPodletReady() {
    messageBus.publish(
      events.COMPANION.channel,
      events.COMPANION.PODLET_READY.topic,
      events.COMPANION.PODLET_READY.sendPayload({
        placementInstructionConfigs: payload
      })
    );
  }

  // Initial in case of early publish
  publishPodletReady();
  interval = setInterval(() => {
    publishPodletReady();
  }, 200);

  // Clear the interval after 2000ms
  setTimeout(() => {
    clearInterval(interval);
  }, 2000);
}
